import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ContactDialogService {
    dialogOpen$: Subject<any> = new Subject<any>();
}
